import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/rocla.svg'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main-header" }
const _hoisted_3 = { class: "mode-links-position" }
const _hoisted_4 = { class: "pl-4 user-info-area main-header" }
const _hoisted_5 = {
  key: 1,
  class: "p-4"
}
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "pl-4 pr-4 center-h",
        src: _imports_0,
        height: "10",
        width: "43"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.licenseGenerationAllowed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
              class: _normalizeClass(["mode-links", _ctx.currentRoute === '/' ? 'mode-links-selected' : ''])
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("a", { class: "pl-4 pr-4" }, "Licenses", -1)
            ]), 2))
          : _createCommentVNode("", true),
        (_ctx.stationAdjustmentAllowed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/bulk_adjustment'))),
              class: _normalizeClass(["mode-links", _ctx.currentRoute === '/bulk_adjustment' ? 'mode-links-selected' : ''])
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("a", { class: "pl-4 pr-4" }, "Bulk Adjustment", -1)
            ]), 2))
          : _createCommentVNode("", true),
        (_ctx.versionGuardAllowed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/version_guard'))),
              class: _normalizeClass(["mode-links", _ctx.currentRoute === '/version_guard' ? 'mode-links-selected' : ''])
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("a", { class: "pl-4 pr-4" }, "Version Guard", -1)
            ]), 2))
          : _createCommentVNode("", true),
        (_ctx.licenseListAllowed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/license_list'))),
              class: _normalizeClass(["mode-links", _ctx.currentRoute === '/license_list' ? 'mode-links-selected' : ''])
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("a", { class: "pl-4 pr-4" }, "License List", -1)
            ]), 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_user_menu, { class: "center-h user-info-area" })
      ])
    ]),
    (_ctx.loggedIn && (_ctx.licenseGenerationAllowed || _ctx.stationAdjustmentAllowed || _ctx.versionGuardAllowed || _ctx.licenseListAllowed))
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.loggedIn)
            ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: "primary",
                href: "Session/SignIn"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Sign in", -1)
                ])),
                _: 1,
                __: [9]
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "License generation has not been enabled for your account. Please contact site administrators."))
        ]))
  ]))
}